module.exports = "pegasus/assets/blocks/column-5-theme3.png";